/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { ReactRoute } from 'embercom/lib/react-route';

class ReferralsRoute extends Route {
  @service declare customerService: $TSFixMe;
  @service declare router: RouterService;

  reactEnabled() {
    return true;
  }

  redirect(): any {
    let customer = this.customerService.customer;
    if (!customer || customer.inTrial || !customer.hasActiveSubscription) {
      return this.router.transitionTo('apps.app.settings.index');
    }
  }
}
export default ReactRoute(ReferralsRoute);
